import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { InfoOutlinedIcon } from 'LegacyWeployDesignLanguage/icons';

import PastJobRow from './PastJobRow';

const StyledRepostingMessage = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing[5]};
`;

const StyledInfoOutlinedIcon = styled(InfoOutlinedIcon)`
  padding-right: ${props => props.theme.spacing[1]};
  color: ${props => props.theme.colors.text.primary};
`;

const StyledSubtitle = styled.div`
  ${props => props.theme.subtitle1}
  color: ${props => props.theme.colors.text.primary};
`;

const RepostableJobsTable = ({ jobs, onChooseClick }) => (
  <>
    <StyledRepostingMessage>
      <StyledInfoOutlinedIcon />
      <StyledSubtitle>
        We’ll copy most of the data of the chosen job. You’ll just need to <strong>fill in the dates.</strong>
      </StyledSubtitle>
    </StyledRepostingMessage>
    <div>
      {jobs.map(job => (
        <PastJobRow
          key={job.id}
          job={job}
          onChooseClick={onChooseClick}
        />
      ))}
    </div>
  </>
);

RepostableJobsTable.propTypes = {
  jobs: PropTypes.array.isRequired,
  onChooseClick: PropTypes.func.isRequired,
};

export default RepostableJobsTable;
